module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av452-031ed418699311d5024d1326464f9721.jpg";